import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { palette } = useTheme()
    const { colors } = useContextState()
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .separator': {
                borderBottom: `1px solid ${palette.grey[400]}`,
                paddingBottom: '5px'
            }
        },
        titleRow: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 0.5,
            minWidth: 0,
            flexWrap: 'wrap',
        },

        inlineStatusWrap: {
            whiteSpace: 'nowrap',
            fontSize: '16px',
            fontWeight: '700',
            lineHeight: 'inherit',
        },

        inlineStatusText: {
            fontSize: 'inherit',
            fontWeight: '700',
            lineHeight: 'inherit',
        },

        tabs: {
            '& .MuiTabs-flexContainer': {
                justifyContent: 'space-between',
            }
        },
        tabsPanel: {
            '&.MuiTabPanel-root': {
                padding: '24px 0px 0px 0px'
            },
        },
        users: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: '24px 0px 0px'
        },
        scroll: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            /* padding: '0px 24px 24px', */
            maxHeight: '350px',
            overflowY: 'auto',
            scrollbarWidth: 'none'
        },
        iconTitle: {
            display: 'flex',
            gap: 1,
            alignItems: 'center'
        },
        icon: {
            '&.icon-action-card': {
                fontSize: '35px'
            }
        },
        iconOutlined: ({ icon }: { icon: string }) => ({
            width: 40,
            height: 40,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ...icon === 'phone' && {
                backgroundColor: colors.color4,
            },
            ...icon === 'email' && {
                backgroundColor: colors.primary,
            },
            '& .icon-action-card': {
                fontSize: '25px',
            }
        }),
        flex: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        containerIcons: {
            display: 'flex',
            alignItems: 'center',
            width: '26%',
            justifyContent: 'end',
            gap: 1
        },
        title: {
            color: colors.color4
        }
    }
}

export { useStyles }
